<template>
  <header :class="{ 'scrolled-nav': scrollPosition }">
    <nav>
      <div class="logo">
        <img src="@/assets/logo.png" alt="" />
        <h2>Interstellar</h2>
      </div>
      <ul v-show="!mobile" class="nav-links">
        <li><router-link class="link" to="/">Home</router-link></li>
        <li><router-link class="link" to="/blog">Blog</router-link></li>
        <li><router-link class="link" to="/about">About</router-link></li>
        <li><router-link class="link" to="/contact">Contact</router-link></li>
      </ul>
      <div v-show="mobile" class="hamburger">
        <i
          class="hamburger-wrapper"
          @click="toggleMobileNav"
          :class="{ 'icon-active': mobileNav }"
        >
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </i>
      </div>
      <!-- call mobile-nav to style -->
      <transition name="mobile-nav">
        <ul v-show="mobileNav" class="dropdown-nav">
          <li @click="toggleMobileNav">
            <router-link class="link" to="/">Home</router-link>
          </li>
          <li @click="toggleMobileNav">
            <router-link class="link" to="/blog">Blog</router-link>
          </li>
          <li @click="toggleMobileNav">
            <router-link class="link" to="/about">About</router-link>
          </li>
          <li @click="toggleMobileNav">
            <router-link class="link" to="/contact">Contact</router-link>
          </li>
        </ul>
      </transition>
    </nav>
  </header>
</template>

<script>
export default {
  name: "global-header",
  data() {
    return {
      scrollPosition: null,
      mobile: null,
      mobileNav: null,
      windowWidth: null,
    };
  },

  // initiator for screen size
  created() {
    window.addEventListener("resize", this.checkScreen);
    this.checkScreen();
  },
  // initiator for scroll event
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
  methods: {
    toggleMobileNav() {
      this.mobileNav = !this.mobileNav;
    },

    updateScroll() {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 50) {
        this.scrolledNav = true;
        return;
      }
      this.scrolledNav = false;
    },

    checkScreen() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 750) {
        this.mobile = true;
        return;
      }
      // so if it goes mobile to desktop it reverts
      this.mobile = false;
      this.mobileNav = false;
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  display: flex;
  z-index: 99;
  width: 100%;
  height: 10%;
  position: fixed;
  transition: 0.5s ease all;

  justify-content: center;

  nav {
    display: flex;
    flex-direction: row;
    padding: 12px 0;
    transition: 0.5s ease all;
    width: 90%;
    justify-content: space-between;
    .logo {
      display: flex;
      align-items: center;

      img {
        width: 50px;
        object-fit: contain;
        transition: 0.5s ease all;
      }
    }

    .nav-links {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex: 1;
    }

    ul,
    .link {
      font-weight: 500;
      color: white;
      list-style: none;
      text-decoration: none;
    }

    li {
      text-transform: uppercase;
      font-family: helvetica;
      padding: 16px;
      margin-left: 16px;
    }

    .link {
      font-size: 17px;
      font-weight: 100;
      transition: 0.5s ease all;
      padding-bottom: 4px;
      border-bottom: 2px solid transparent;

      &:hover {
        border-color: white;
      }
    }
  }
  .hamburger {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    .hamburger-wrapper {
      display: inline-block;
      width: 30px;
      height: 20px;
      position: relative;
      cursor: pointer;
      align-items: center;
    }
    .bar {
      display: block;
      width: 100%;
      height: 2px;
      background-color: white;
      position: absolute;
      border-radius: 2px;
      left: 0;
      transition: transform 0.3s ease;

      &:nth-child(1) {
        top: 0;
      }
      &:nth-child(2) {
        top: 50%;
        transform: translatey(-50%);
      }
      &:nth-child(3) {
        bottom: 0;
      }
    }
    .icon-active {
      .bar:nth-child(1) {
        transform: translateY(9px) rotate(45deg);
      }

      .bar:nth-child(2) {
        opacity: 0;
      }

      .bar:nth-child(3) {
        transform: translateY(-9px) rotate(-45deg);
      }
    }
  }

  .dropdown-nav {
    display: flex;
    flex-direction: column;
    position: fixed;
    width: 100%;
    max-width: 250px;
    height: 100%;
    background-color: white;
    top: 0;
    left: 0;

    li {
      margin-left: 0;
      .link {
        color: black;
      }
    }
  }
  .mobile-nav-enter-active,
  .mobile-nav-leave-active {
    transition: 1s ease all;
  }

  .mobile-nav-enter-from,
  .mobile-nav-leave-to {
    transform: translateX(-550px);
  }

  .mobile-nav-enter-to {
    transform: translateX(0);
  }
}

.scrolled-nav {
  background-color: black;
  box-shadow: 0 4px 6px -1px;

  nav {
    padding: 8px 0;
  }

  .branding {
    img {
    }
  }
}
</style>
